export const name = 'gzColumnsDialogController';
export default function gzColumnsDialogController(
  columns,
  pairingId,
  $translate,
  $mdDialog,
  rnPreferences,
  $gzAnalytics
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let vm = this;

  let gridPreferences;
  vm.moveUpDisabled = moveUpDisabled;
  vm.moveDownDisabled = moveDownDisabled;
  vm.columnClicked = columnClicked;
  vm.moveUp = moveUp;
  vm.moveDown = moveDown;
  vm.togglePin = togglePin;
  vm.submit = submit;

  activate();

  //////////////////

  function activate() {
    return rnPreferences.getAll().then((prefs) => {
      vm.displayColumns = [];
      if (prefs.gzGrid) {
        gridPreferences = rnPreferences.getPrefObjectHelper(prefs, 'gzGrid', pairingId);
        let columnPrefs = gridPreferences.columnPrefs;
        let columnOrder = gridPreferences.columnOrder;
        if (columnOrder) {
          _.forEach(columns, column => {
            let allowShow = _.get(column, 'options.allowShow', true);
            if (allowShow) {
              let index = columnOrder.indexOf(column.id);
              if (index < 0) {
                index = 1000;
              }
              _.set(column, 'sortIndex', index);

              if (columnPrefs) {
                column.visible = columnPrefs[column.id].show;
                column.pinned = columnPrefs[column.id].pinned === 'left';
              }
              vm.displayColumns.push(column);
            }
          });

          vm.displayColumns = _.sortBy(vm.displayColumns, 'sortIndex');
        }
      }
    });
  }

  function submit() {

    vm.processing = true;
    let columnOrder = [];
    let columnPrefs = {};
    let columnVisible = [];
    let columnPinned = [];
    if (gridPreferences && gridPreferences.columnPrefs) {
      columnPrefs = gridPreferences.columnPrefs;
    }
    _.forEach(vm.displayColumns, column => {
      columnOrder.push(column.id);
      if (gridPreferences && gridPreferences.columnPrefs) {
        let found = gridPreferences.columnPrefs[column.id];
        found.show = column.visible;
        if(found.show){
          columnVisible.push(column.id);
        }

        if (column.pinned) {
          found.pinned = 'left';
          columnPinned.push(column.id);
        }
        else {
          delete found.pinned;
        }
      }
      else {
        let pref = {
          show: column.visible
        };
        if(pref.show){
          columnVisible.push(column.id);
        }
        if (column.pinned) {
          pref.pinned = 'left';
          columnPinned.push(column.id);
        }
      }
    });
    let prefs = {
      columnOrder: columnOrder,
      columnPrefs: columnPrefs
    };

    rnPreferences.setSingleObject('gzGrid', pairingId, prefs).then(() => {
      vm.processing = false;
      $gzAnalytics.eventSave(`Grid (${pairingId}) - Columns`, {label: `Order: ${JSON.stringify(columnOrder)}, Visible: ${JSON.stringify(columnVisible)}, Pinned: ${JSON.stringify(columnPinned)}`});
      $mdDialog.hide(prefs);
    })
      .finally(() => {
        vm.processing = false;
      });
  }

  function columnClicked(column) {
    if (vm.selected && vm.selected.id === column.id) {
      delete vm.selected;
    }
    else {
      vm.selected = column;
    }
  }

  function moveUpDisabled() {
    if (!vm.selected) {
      return true;
    }

    return vm.displayColumns.indexOf(vm.selected) === 0;
  }

  function moveDownDisabled() {
    if (!vm.selected) {
      return true;
    }

    return vm.displayColumns.indexOf(vm.selected) === vm.displayColumns.length - 1;
  }

  function moveUp(event) {
    event.stopPropagation();
    let index = vm.displayColumns.indexOf(vm.selected);
    if (index > 0) {
      _.remove(vm.displayColumns, {id: vm.selected.id});
      vm.displayColumns.splice(index-1, 0, vm.selected);
    }
  }

  function moveDown(event) {
    event.stopPropagation();
    let index = vm.displayColumns.indexOf(vm.selected);
    if (index < vm.displayColumns.length - 1) {
      _.remove(vm.displayColumns, {id: vm.selected.id});
      vm.displayColumns.splice(index+1, 0, vm.selected);
    }
  }

  function togglePin(event, column) {
    if(column.pinned){
      $gzAnalytics.eventClick(`Grid (${pairingId}) - Column unpinned`, {label: `ColId: ${column.id}, Pinned: ${column.pinned}` });
    }else{
      $gzAnalytics.eventClick(`Grid (${pairingId}) - Column pinned`, {label: `ColId: ${column.id}, Pinned: ${column.pinned}` });
    }
    event.stopPropagation();
    column.pinned = !column.pinned;
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/extensions/grid/columns/columns-dialog.controller.js